import { render, staticRenderFns } from "./AreaListPage.vue?vue&type=template&id=5a35ec2a&scoped=true"
import script from "./AreaListPage.vue?vue&type=script&lang=js"
export * from "./AreaListPage.vue?vue&type=script&lang=js"
import style0 from "./AreaListPage.vue?vue&type=style&index=0&id=5a35ec2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a35ec2a",
  null
  
)

export default component.exports